import { render, staticRenderFns } from "./stage-manage.vue?vue&type=template&id=095fdc5e&scoped=true"
import script from "./stage-manage.vue?vue&type=script&lang=js"
export * from "./stage-manage.vue?vue&type=script&lang=js"
import style0 from "./stage-manage.vue?vue&type=style&index=0&id=095fdc5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095fdc5e",
  null
  
)

export default component.exports